<template>
  <div class="base-report report-sales-payment">
    <div class="filter">
      <el-form inline>
        <el-select v-model="searchForm.method" size="mini" >
          <el-option
            v-for="item in methods"
            :key="item.value"
            :label="item.label"
            :value="item.value">
          </el-option>
        </el-select>
        <el-date-picker
          v-model="searchForm.from_date"
          type="date"
          size="mini"
          placeholder="開始日"
          value-format="yyyy-MM-dd"
          :clearable="false">
        </el-date-picker>
        <el-date-picker
          v-model="searchForm.to_date"
          type="date"
          size="mini"
          placeholder="終了日"
          value-format="yyyy-MM-dd"
          :clearable="false">
        </el-date-picker>
        <el-button size="mini" type="primary" @click="fetchData" :disabled="isLoading">表示</el-button>
        <div style="float: right; padding-right: 20px;">
          <el-button v-show="$store.getters.isPC && screenData.length>0" size="mini" type="success" icon="el-icon-download" @click="exportCSV">ダウンロード</el-button>
        </div>
      </el-form>
    </div>
    <div class="table_data" v-loading="isLoading">
      <template v-if="screenData.length>0">
        <el-table
          :data="screenData"
          border
          stripe
          show-summary
          height="100%"
          :summary-method="getSummaries">
          <template v-for="(header, index) in tableSetting">
            <template v-if="header.prop === 'date' && currentMethod === methodType.daily">
              <el-table-column
                :key=header.prop
                :label=header.label
                :prop=header.prop
                :formatter="formatter"
                :fixed=header.fixed
                :align=header.align
                :sortable=header.sortable
                :min-width=header.width>
                <template slot-scope="scope">
                  <div class="date">
                    {{ scope.row.date|date }}
                    <span class="w" :class="weekdayClass(scope.row)">{{ printWeekday(scope.row) }}</span>
                  </div>
                </template>
              </el-table-column>
            </template>
            <template v-else-if="header.prop === 'date' && currentMethod === methodType.weekdaily">
              <el-table-column
                :key=header.prop
                :label=header.label
                :prop=header.prop
                :formatter="formatter"
                :fixed=header.fixed
                :align=header.align
                :sortable=header.sortable
                :min-width=header.width>
                <template slot-scope="scope">
                  <div class="date">
                    <span class="w" :class="weekdayClassByWeekdayName(scope.row.weekdayName)">{{ scope.row.weekdayName }}</span>
                  </div>
                </template>
              </el-table-column>
            </template>
            <template v-else-if="!Array.isArray(header)">
              <el-table-column
                :key=header.prop
                :label=header.label
                :prop=header.prop
                :formatter="formatter"
                :fixed=header.fixed
                :align=header.align
                :sortable=header.sortable
                :min-width=header.width>
                <template v-if="Array.isArray(tableSetting[index + 1])">
                  <template v-for="(subheader, subindex) in tableSetting[index + 1]">
                    <el-table-column
                    :key="subheader.prop + subindex"
                    :label=subheader.label
                    :prop=subheader.prop
                    :min-width=subheader.width
                    align="right"
                    :sortable=subheader.sortable
                    :formatter="formatter">
                    </el-table-column>
                  </template>
                </template>
              </el-table-column>
            </template>
          </template>
        </el-table>
      </template>
      <div v-else v-show="noData">
        データがありません。<br>
        条件を変えて再度「表示」ボタンを押してください。
      </div>
    </div>
  </div>
</template>

<script>
import {mapActions, mapGetters} from 'vuex'
import moment from 'moment'
import addFigure from '@/misc/addFigure.js'
import downloadCSV from '@/misc/downloadCSV.js'
import utils from '@/misc/utils.js'

export default {
  name: 'ReportSalesPayment',
  data () {
    const methodType = {
      daily: 1,
      monthly: 2,
      weekdaily: 3,
      hourly: 4,
      orderHourly: 5,
    }
    const targetType = {
      item: 1,
      payment: 2,
      category: 3,
    }

    return {
      ratioStr: null,
      isLoading: false,
      noData: false,
      methodType: {...methodType},
      methods: [{value: methodType.daily, label: '日毎'}, {value: methodType.monthly, label: '月毎'}, {value: methodType.weekdaily, label: '曜日毎'}, {value: methodType.hourly, label: '時間毎'}],
      tableSetting: [],
      searchForm: {
        target: targetType.payment,
        method: methodType.daily,
        from_date: null,
        to_date: null,
      },
      items: [],
      groupData: {},
      currentMethod: methodType.daily,
      orgData: [],
      totalData: [],
      form: {},
      csv_filename: '売上詳細.csv',
    }
  },
  filters: {
    date (value) {
      return moment(value).format('YYYY/MM/DD')
    },
  },
  computed: {
    ...mapGetters('holiday', ['holidays']),
    ...mapGetters('report', ['ratioStrFunction']),
    screenData () {
      let result = []
      for (let data of this.orgData) {
        let record = data.data
        this.calcDateValue(record)

        if (record.payments) {
          for (let payment of record.payments) {
            const code = `${payment.code}_${payment.name}`
            let countKey = code + '_paymentCount'
            let priceKey = code + '_paymentPrice'
            record[priceKey] = payment.amount
            record[countKey] = payment.count
          }
        }
        if (record.discounts) {
          for (let discount of record.discounts) {
            const code = `${discount.code}_${discount.name}`
            let countKey = code + '_discountCount'
            let priceKey = code + '_discountPrice'
            record[priceKey] = discount.amount
            record[countKey] = discount.count
          }
        }
        if (record.servicecharges) {
          for (let servicecharge of record.servicecharges) {
            const code = `${servicecharge.code}_${servicecharge.name}`
            let countKey = code + '_servicechargeCount'
            let priceKey = code + '_servicechargePrice'
            record[priceKey] = servicecharge.amount
            record[countKey] = servicecharge.count
          }
        }
        if (record.taxes) {
          for (let tax of record.taxes) {
            const code = `${tax.code}_${tax.name}`
            let taxKey = code + '_tax'
            let taxableAmountKey = code + '_taxableAmount'
            record[taxKey] = tax.tax
            record[taxableAmountKey] = tax.taxableAmount
          }
        }

        // update stay
        record.averageStay = utils.divide(record.stay, record.party)

        result.push(record)
      }
      return result
    },
    totalStay () {
      return this.orgData.reduce((a, b) => a + b.data.stay, 0)
    },
  },
  created () {
    this.ratioStr = this.ratioStrFunction
  },
  mounted () {
    this.getHolidays()
    this.searchForm.from_date = moment().date(1).format('YYYY-MM-DD')
    this.searchForm.to_date = moment().format('YYYY-MM-DD')
  },
  methods: {
    ...mapActions('holiday', ['getHolidays']),
    fetchData () {
      this.isLoading = true
      this.noData = false
      this.items = []
      this.tableSetting = []
      this.totalData = []
      this.orgData = []
      this.currentMethod = this.searchForm.method

      this.$request.reports.details(this.searchForm.from_date, this.searchForm.to_date, this.searchForm.method, this.searchForm.target, this.searchForm.mode).then(res => {
        this.items = res.body
        if (this.items) {
          this.tableSetting.push({label: this.getDateStr(), prop: 'date', align: 'center', fixed: true, sortable: true, width: '130px'})
          this.tableSetting.push({label: '売上', prop: 'sales', align: 'right', sortable: true, width: '130px'})
          this.tableSetting.push({label: '売上(税抜)', prop: 'salesExcludeTax', align: 'right', sortable: true, width: '130px'})

          this.tableSetting.push({label: '税対象金額'})
          let taxes = this.items.headers.taxes
          let taxableAmount = []
          taxes.forEach(tax => {
            let code = `${tax.code}_${tax.name}`
            taxableAmount.push({label: tax.name, prop: code + '_taxableAmount', sortable: true, width: '80px'})
          })
          this.tableSetting.push(taxableAmount)

          this.tableSetting.push({label: '税', prop: 'tax', align: 'right', sortable: true, width: '130px'})

          this.tableSetting.push({label: '税詳細'})
          let taxDetail = []
          taxes.forEach(tax => {
            let code = `${tax.code}_${tax.name}`
            taxDetail.push({label: tax.name, prop: code + '_tax', sortable: true, width: '80px'})
          })
          this.tableSetting.push(taxDetail)

          this.tableSetting.push({label: '組数', prop: 'party', align: 'right', sortable: true, width: '80px'})
          this.tableSetting.push({label: '組単価', prop: 'partySales', align: 'right', sortable: true, width: '100px'})
          this.tableSetting.push({label: '客数', prop: 'person', align: 'right', sortable: true, width: '80px'})
          this.tableSetting.push({label: '客単価', prop: 'personSales', align: 'right', sortable: true, width: '100px'})

          let payments = this.items.headers.payments
          payments.forEach(payment => {
            let code = `${payment.code}_${payment.name}`
            this.tableSetting.push({
              label: payment.name,
              code: code,
            })
            this.tableSetting.push([
              {label: '件数', prop: code + '_paymentCount', sortable: true, width: '80px'},
              {label: '金額', prop: code + '_paymentPrice', sortable: true, width: '120px'},
            ])
          })

          let discounts = this.items.headers.discounts
          discounts.forEach(discount => {
            let code = `${discount.code}_${discount.name}`
            this.tableSetting.push({
              label: discount.name,
              code: code,
            })
            this.tableSetting.push([
              {label: '件数', prop: code + '_discountCount', sortable: true, width: '80px'},
              {label: '金額', prop: code + '_discountPrice', sortable: true, width: '120px'},
            ])
          })
          this.tableSetting.push({label: '割引・割増合計', prop: 'totalDiscount', sortable: true, align: 'right', width: '130px'})

          let servicecharges = this.items.headers.servicecharges
          servicecharges.forEach(servicecharge => {
            let code = `${servicecharge.code}_${servicecharge.name}`
            this.tableSetting.push({
              label: servicecharge.name,
              code: code,
            })
            this.tableSetting.push([
              {label: '件数', prop: code + '_servicechargeCount', sortable: true, width: '80px'},
              {label: '金額', prop: code + '_servicechargePrice', sortable: true, width: '120px'},
            ])
          })
          this.tableSetting.push({label: 'サービス料合計', prop: 'totalServicecharge', sortable: true, align: 'right', width: '130px'})

          this.tableSetting.push({label: '万券', prop: 'man', sortable: true, align: 'right', width: '100px'})
          this.tableSetting.push({label: '印紙', prop: 'stampTax', sortable: true, align: 'right', width: '100px'})
          this.tableSetting.push({label: 'オプション', prop: 'option', sortable: true, align: 'right', width: '130px'})
          this.tableSetting.push({label: '滞在時間', prop: 'averageStay', sortable: true, align: 'right', width: '100px'})
          this.tableSetting.push({label: '男性', prop: 'male', sortable: true, align: 'right', width: '80px'})
          this.tableSetting.push({label: '女性', prop: 'female', sortable: true, align: 'right', width: '80px'})
          this.tableSetting.push({label: '10代', prop: 'teens', sortable: true, align: 'right', width: '80px'})
          this.tableSetting.push({label: '20代', prop: 'twenties', sortable: true, align: 'right', width: '80px'})
          this.tableSetting.push({label: '30代', prop: 'thirties', sortable: true, align: 'right', width: '80px'})
          this.tableSetting.push({label: '40代', prop: 'forties', sortable: true, align: 'right', width: '80px'})
          this.tableSetting.push({label: '50代', prop: 'fifties', sortable: true, align: 'right', width: '80px'})
          this.tableSetting.push({label: '60代', prop: 'sixties', sortable: true, align: 'right', width: '80px'})
          this.tableSetting.push({label: '新規顧客', prop: 'newCustomer', sortable: true, align: 'right', width: '80px'})
          this.tableSetting.push({label: '属性A', prop: 'attributeA', sortable: true, align: 'right', width: '80px'})
          this.tableSetting.push({label: '属性B', prop: 'attributeB', sortable: true, align: 'right', width: '80px'})
          this.tableSetting.push({label: '属性C', prop: 'attributeC', sortable: true, align: 'right', width: '80px'})
          this.tableSetting.push({label: '属性D', prop: 'attributeD', sortable: true, align: 'right', width: '80px'})
          this.tableSetting.push({label: '属性E', prop: 'attributeE', sortable: true, align: 'right', width: '80px'})

          for (let record of this.items.records) {
            this.orgData.push(record)
          }
        }

        // get groups data
        if (this.items.groups) {
          for (let group of this.items.groups) {
            this.groupData[group.key] = group
          }
        }
      }, err => {
        console.log(err)
      }).finally(() => {
        this.isLoading = false
        this.noData = !this.screenData.length
      })
    },
    getSummaries ({columns, data}) {
      let totalDic = {}
      let seft = this
      columns.forEach((column, index) => {
        if (index === 0) {
          this.totalData[index] = '合計'
          return true
        }
        let prop = columns[index].property
        let reducer = function (a, b) {
          let valb = parseFloat(b[columns[index].property]) || 0
          return a + valb
        }
        let values = data.reduce(reducer, 0)
        totalDic[prop] = values

        switch (prop) {
          case 'partySales':
            values = utils.divide(totalDic.sales, totalDic.party)
            break
          case 'personSales':
            values = utils.divide(totalDic.sales, totalDic.person)
            break
          case 'averageStay':
            values = utils.divide(seft.totalStay, totalDic.party)
            break
        }
        this.totalData[index] = this.formatData(prop, values)
      })

      return this.totalData
    },
    exportCSV () {
      let header = []
      let keyList = []
      for (let tableHeader of this.tableSetting) {
        if (Array.isArray(tableHeader)) {
          let preHeader = header.pop()
          for (let subHeader of tableHeader) {
            if (subHeader.prop) {
              keyList.push(subHeader.prop)
            }
            header.push(`${preHeader}-${subHeader.label}`)
          }
        } else {
          if (tableHeader.prop) {
            keyList.push(tableHeader.prop)
          }
          header.push(tableHeader.label)
        }
      }
      let data = []
      for (let record of this.screenData) {
        let tmp = []
        for (let key of keyList) {
          tmp.push(this.formatData(key, record[key]))
        }
        data.push(tmp)
      }

      downloadCSV(this.csv_filename, header, data, this.totalData)
    },
    date (value) {
      let result = '-'
      switch (this.currentMethod) {
        case this.methodType.daily:
          let date = moment(value).format('YYYY/MM/DD')
          let day = moment(value).locale('ja').format('ddd')
          result = date + '(' + day + ')'
          break
        case this.methodType.monthly:
          result = moment(value).format('YYYY年MM月')
          break
        case this.methodType.weekdaily:
          result = value
          break
        case this.methodType.hourly:
          result = value + ':00〜' + value + ':59'
          break
        case this.methodType.orderHourly:
          result = value + ':00〜' + value + ':59'
          break
      }
      return result
    },
    getDateStr () {
      switch (this.currentMethod) {
        case this.methodType.daily:
          return '年月日'
        case this.methodType.monthly:
          return '年月'
        case this.methodType.weekdaily:
          return '曜日'
        case this.methodType.hourly:
          return '時間'
        case this.methodType.orderHourly:
          return '時間'
      }
    },
    calcDateValue (record) {
      switch (this.currentMethod) {
        case this.methodType.daily:
          record.date = record.date
          break
        case this.methodType.monthly:
          record.date = record.date
          break
        case this.methodType.weekdaily:
          record.date = record.weekdayName
          break
        case this.methodType.hourly:
          record.date = record.hour
          break
        case this.methodType.orderHourly:
          record.date = record.hour
          break
      }
    },
    formatter (row, column) {
      let key = column.property
      return this.formatData(key, row[key])
    },
    formatData (key, value) {
      switch (key) {
        case 'date':
          return this.date(value)
        case 'code':
          return value
        case 'name':
          return value
        case 'itemCode':
          return value
        case 'itemName':
          return value
        case 'salesRatio':
          return this.ratioStr(value)
        case 'countRatio':
          return this.ratioStr(value)
        case 'categoryCode':
          return value
        case 'categoryName':
          return value
        case 'averageStay':
          return utils.formatStay(value)
        default:
          return addFigure(parseInt(value))
      }
    },
    isHoliday (date, before = false) {
      const k = before ? moment(date).add(1, 'days').format('YYYY-MM-DD') : moment(date).format('YYYY-MM-DD')
      if (this.holidays[k]) {
        return true
      }
      return false
    },
    printWeekday (item) {
      if (this.isHoliday(item.date)) {
        return '祝'
      }
      return moment(item.date).locale('ja').format('ddd')
    },
    weekdayClass (item) {
      if (this.isHoliday(item.date)) {
        return 'hol'
      }
      let ret = moment(item.date).locale('en').format('ddd').toLowerCase()
      if (ret !== 'sun' && this.isHoliday(item.date, true)) {
        return 'bho'
      }
      return ret
    },
    weekdayClassByWeekdayName (name) {
      if (name === '日') {
        return 'sun'
      } else if (name === '土') {
        return 'sat'
      } else if (name === '祝') {
        return 'hol'
      }
    },
  },
}
</script>

<style lang="sass">
@import "static/sass/report/common.sass"
</style>

<style scoped>
div.date {
  text-align: center;
  height: 40px;
  line-height: 40px;
}

div.date span.w {
  display: inline-block;
  width: 16px;
  height: 16px;
  margin-left: 4px;
  background-color: #ABC;
  border-radius: 50%;
  line-height: 16px;
  font-size: 0.7em;
  text-align: center;
  color: #FFF;
  vertical-align: 2px;
}

div.date span.w.sat,
div.date span.w.bho {
  background-color: #3CD;
}

div.date span.w.sun,
div.date span.w.hol {
  background-color: #E34;
}
</style>



// WEBPACK FOOTER //
// src/components/Report/ReportSalesPayment.vue